<style type="text/scss">
  @import '../../styles/vars';

  .card {
    background: #fff;
    border-radius: 4px;

    box-shadow: -1px 0 62px -6px rgba(0, 0, 0, 0.15);
    box-shadow: 0 2px 2px 0 rgba(23, 28, 33, 0.06);
    height: calc(100% - 16px);
    display: flex;
    margin-bottom: 16px;
    border: none;
    position: relative;

    transition: all 0.3s;
    cursor: pointer;

    :global(.stat) {
      padding: 16px;
      background: #fbfbfb;
      height: auto;
    }

    :global(.stat-darker) {
      padding: 16px;
      background: darken(#fbfbfb, 1);
      height: auto;
    }

    :global(.stat-darker.end) {
      height: 100%;
    }

    :global(.stat.end) {
      height: 100%;
    }

    :global(.card-inner) {
      height: 100%;
    }
  }

  .card.hover:hover {
    transform: translateY(-4px);
    box-shadow: -1px 0 32px -6px rgba(0, 0, 0, 0.15);
  }

  div :global(a) {
    text-decoration: none;
  }

  div :global(p) {
    font-family: 'Roboto', sans-serif;
    color: #525252;
    font-weight: 500;
    font-size: 13px;
    line-height: 21.034px;
  }

  div :global(hr) {
    border-top: 1px solid #4c4c4b;
    opacity: 0.1;
    border-bottom: 0;
    padding: 0;
    width: 100%;
    height: 1px;
    margin: 0;
  }

  div :global(h3) {
    font-family: 'Lato', sans-serif;
    color: #424242;
    font-weight: 600;
    font-size: 17px;
    line-height: 21.034px;
    -webkit-font-smoothing: antialiased;
    margin: 0;
  }

  div :global(h4) {
    font-family: 'Lato', sans-serif;
    color: #4c4c4b;
    font-weight: 500;
    font-size: 12px;
    line-height: 21.034px;
    text-transform: uppercase;
    margin: 0;
  }

  div :global(h5) {
    font-family: 'Roboto', sans-serif;
    color: #424242;
    font-weight: 500;
    font-size: 15px;
    line-height: 21.034px;
    text-transform: uppercase;
    margin: 0;
  }

  div :global(h6) {
    font-family: 'Lato', sans-serif;
    color: #4c4c4b;
    font-weight: 500;
    font-size: 10px;
    line-height: 21.034px;
    text-transform: uppercase;
    margin: 0;
  }

  div :global(.u--padall) {
    padding: 16px;
  }

  div :global(.u--pad-vertical) {
    padding: 16px 0;
  }

  div :global(.u--margin) {
    margin: 16px 0;
  }

  .border.selected {
    border: 2px solid #ff6452;
  }

  .border {
    border: 2px solid transparent;
  }
</style>

<script>
  export let selected = false;
  export let hover = false;
  export let bordered = false;
</script>

<div
  on:click
  class:hover="{hover}"
  class:border="{bordered}"
  class:selected="{selected}"
  class="card"
>
  <div class="card-inner">
    <slot></slot>
  </div>
</div>
